<template>
    <Head title="Create Award Group"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl leading-tight">
                Create Award Group
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data"
                      @submit.prevent="create.post(requestUrl, { preserveScroll: true})"
                      class="w-full">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Name</admin-app-label>
                            <input-basic
                                placeholder="Name"
                                v-model="create.name"
                                :error="errors['name']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.name }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Order</admin-app-label>
                            <input-basic
                                type="number"
                                placeholder="Order"
                                v-model="create.order"
                                :error="errors['order']"
                            />
                            <p class="text-sm text-placeholder mt-1">
                                This sets the order of the award on the awards page. <strong>0</strong> being first.
                            </p>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Year</admin-app-label>
                            <input-select
                                placeholder="Year"
                                label-key="Year"
                                v-model="create.year"
                                :options="years"
                                :error="errors['year']"
                                label="year"/>
                        </div>
                        <div class="mb-6 md:mb-5">
                            <admin-app-label>Season</admin-app-label>
                            <input-select
                                placeholder="Season"
                                label-key="Season"
                                v-model="create.season"
                                :options="seasons"
                                :error="errors['season']"
                                label="season"/>
                        </div>
                        <div class="mb-6 md:mb-5">
                            <admin-app-label>Classification</admin-app-label>
                            <input-select
                                placeholder="Classification"
                                label-key="Classification"
                                v-model="create.application"
                                :options="classifications"
                                :error="errors['application']"
                                label="classification"
                                :reduce="classification => classification.classification"
                            />
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Related Review</admin-app-label>
                        <input-select
                            placeholder="Steves Review"
                            label-key="title"
                            v-model="create.post_id"
                            :options="posts"
                            :error="errors['post_id']"
                            label="title"
                            :reduce="posts => (posts.id)"
                        />
                    </div>
                    <app-button type="submit" :disabled="create.processing" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import AppButton from "@/Components/AppButton";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputError from "@/Components/Forms/Inputs/InputError";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import {Head, useForm} from "@inertiajs/inertia-vue3";

export default {
    name: "Create",
    components: {
        AppButton,
        AdminAppLabel,
        BreezeAuthenticatedLayout,
        BreadCrumbs,
        FontAwesomeIcon,
        InputBasic,
        InputError,
        InputSelect,
        Head,
    },
    props: {
        seasons: Object,
        classifications: Object,
        years: Object,
        posts: Object,
        errors: Object,
        requestUrl: {
            type: String,
            default: "/admin/award-groups"
        }
    },
    data()
    {
        return {
            navItems: [
                {title: "Award Groups", path: "/admin/award-groups"},
                {title: "Create New", path: "/admin/award-groups/create"},
            ],
            create: useForm(
                {
                    name: "",
                    season: "",
                    year: "",
                    application: "",
                    order: "",
                    post_id: ""
                }
            )
        }
    },
    methods:
    {

    }
}
</script>

<style scoped>

</style>
